import { useCallback, useEffect, useRef } from 'react'
import { useParams } from 'react-router-dom'

import { Button } from 'twyne-new.ui'

import { useGrid } from '@Components/Grid'

import buildSiteUrl from '../../../utils/site-url'
import { FINISHED, RUNNING, useBulkPublish } from '../../builder/bulk-publish/context'

export default function BulkPublishAction() {
  const { rowsSelected, setRowsSelected, handleRefresh, store: { collections: { items } } } = useGrid()
  const { content_type: contentType } = useParams()
  const { status, start } = useBulkPublish()

  useRefreshWhenFinished(status, handleRefresh)

  const handlePublish = useCallback(() => {
    start({ contentType, entries: buildEntries(rowsSelected, items) })
    setRowsSelected([])
  }, [start, contentType, rowsSelected, items, setRowsSelected])

  return <Button
    variant='light'
    color='accent'
    size='sm'
    onClick={handlePublish}
    disabled={!rowsSelected.length || status === RUNNING}
  >
    Publish
  </Button>
}

function useRefreshWhenFinished(status, handleRefresh) {
  const previousRef = useRef(status)

  useEffect(() => {
    if (previousRef.current === RUNNING && status === FINISHED) {
      handleRefresh()
    }

    previousRef.current = status
  }, [status, handleRefresh])
}

function buildEntries(rowsSelected, items) {
  return rowsSelected.map(rowId => {
    const row = items.find(({ id }) => `${id}` === `${rowId}`)

    return {
      id: rowId,
      title: row?.title || '',
      slug: row?.slug || '',
      url: buildSiteUrl(row?.route?.path) || '',
    }
  })
}
